import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, className = "", ...props }) => {
  try {
    if (!IconComponent) {
      // Returner et nøytralt, tomt element eller fallback hvis ikonet mangler
      return <span className={`inline-block w-4 h-4 bg-gray-200 rounded ${className}`} {...props} />;
    }
    return <IconComponent className={className} {...props} />;
  } catch (error) {
    console.error("Icon render error:", error);
    return <FiAlertTriangle className={`text-red-500 ${className}`} {...props} />;
  }
};

export default SafeIcon;